import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class GroupSelectListComponent implements IController {
  selectedId: any;
  optionIds: any;
  excludeIds: any;
  onChange: Function;

  private groupsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $groups, private $infiniteScroll) {
  }

  $onInit() {
    this.groupsRef = this.$groups();
    this.loadLimit = 20;

    this.groupsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.groupsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  private _reload() {
    this.groupsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString
    };
  }
}

angular
  .module('bringoz.admin.groups')
  .component('groupSelectList', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./group-select-list.html').default,
    controller: GroupSelectListComponent
  });
